import servicesUtils from "../../../utils/servicesUtils";
var getMatchingPatient = function getMatchingPatient(patient_id) {
  return servicesUtils.getService("/patients/".concat(patient_id, "/match/?threshold=50"));
};
export default getMatchingPatient;